const utils = {};

utils.countObjects = function (arr, field) {
    const initial = {};
    const count = arr.reduce((agg, current, index, initial) => {
        const fieldType = current[field];
        if (agg[fieldType]) {
            agg[fieldType] += 1;
        } else {
            agg[fieldType] = 1;
        }
        return agg;
    }, initial)
    const countArr = []
    for (let key in count) {
        countArr.push(`${count[key]} (${key})`)
    }
    return countArr.join(', ');
}

utils.groupObjects = function (arr, field) {
    const initial = {};
    const group = arr.reduce((agg, current, index, initial) => {
        const fieldType = current[field];
        if (agg[fieldType]) {
            agg[fieldType].push(current);
        } else {
            agg[fieldType] = [current];
        }
        return agg;
    }, initial);

    // const groupArr = []
    // for (let key in group) {
    //     let obj = {};
    //     obj[key] = group[key];
    //     groupArr.push(obj)
    // }
    // console.log(groupArr);
    return group;
}

export default utils;


// WEBPACK FOOTER //
// ./src/utils/array.js